'use strict'

import {graphqlbase} from './_graphqlbase.js'

class molecules_article_list extends graphqlbase {
	constructor(base) {
		super(base)

		this.query = `query BasicArticleQuery{
          nodeQuery (filter: {conditions: [{operator: EQUAL, field: "type", value: ["article"]}]}) {
            entities {
              ... on NodeArticle {
                entityId
                entityLabel
                body {
                  value
                }
              }
            }
          }
        }`

		//let filter = {filter: '(filter: {conditions: [{operator: EQUAL, field: "type", value: ["article"]}]})'}
		//this.query = this.build_nodequery({'... on NodeArticle': ['entityId', 'entityLabel', 'body {value}']}, filter)
		this.fetch()
	}

	render(articles) {
		const rendered = this.render_list(articles, this.render_item)

		this.loader.hide()
		this.base.insertAdjacentHTML('afterbegin', rendered)
	}

	render_item({entityLabel, body}) {
		const template = require('../templates/_article/article.tpl')

		return template({
			entityLabel,
			body,
		})
	}
}

const selector = document.body.querySelectorAll('[data-graph="articlellist"]')
if (selector[0]) {
	const articlelist = new molecules_article_list(selector[0])
}